export default "__VITE_ASSET__DKz8KJ1I__"